export const GET_SCHEDULES_REQUEST = "GET_SCHEDULES_REQUEST";
export const GET_SCHEDULES_LIST_REQUEST = "GET_SCHEDULES_LIST_REQUEST";
export const GET_SCHEDULES_SUCCESS = "GET_SCHEDULES_SUCCESS";
export const GET_SCHEDULES_FAILURE = "GET_SCHEDULES_FAILURE";
export const GET_SCHEDULES_PENDING = "GET_SCHEDULES_PENDING";
